export function parseVendureNameParts(vendureName: string): string[] {
  return vendureName.split(/\s+(?=\[\d+\]_)/);
}

export function extractOrderNumber(text: string): number {
  const match = text.match(/^\[0*(\d+)\]_/);
  return match ? parseInt(match[1], 10) : Infinity;
}

export function removeOrderPrefix(text: string): string {
  return text.replace(/^\[\d+\]_/, "");
}

export function sortByOrderPrefix<T>(items: T[], key: keyof T): T[] {
  return [...items].sort((a, b) => {
    const textA = String(a[key] ?? "");
    const textB = String(b[key] ?? "");

    const orderA = extractOrderNumber(textA);
    const orderB = extractOrderNumber(textB);

    if (orderA !== Infinity && orderB !== Infinity) {
      return orderA - orderB;
    }

    if (orderA === Infinity && orderB === Infinity) {
      return textA.localeCompare(textB);
    }

    return orderA === Infinity ? 1 : -1;
  });
}

export function sortAndCleanByOrderPrefix<T>(items: T[], key: keyof T): T[] {
  const sorted = sortByOrderPrefix(items, key);
  return sorted.map((item) => ({
    ...item,
    [key]: removeOrderPrefix(String(item[key] ?? "")),
  }));
}
